import styled from 'styled-components'

import { media } from '../../styles/media'

const Separator = styled.hr`
  display: none;
  margin: 0;
  padding: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.textGreyLight};

  ${media.md`
    display: block;
  `}
`

export default Separator
